import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgX = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 7 7 17M7 7l10 10" />
  </svg>
)
const ForwardRef = forwardRef(SvgX)
export default ForwardRef
